"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const styled_components_1 = require("styled-components");
const component_link_1 = require("@patternplate/component-link");
const component_icon_1 = require("@patternplate/component-icon");
const StyledLink = styled_components_1.default(component_link_1.Link) `
  display: block;
  margin: 0 auto;
  &:link,
  &:visited {
    color: ${props => props.theme.colors.active};
  }
`;
const InnerLogo = props => {
    if (props.source) {
        return (React.createElement("div", { className: props.className },
            React.createElement(StyledLink, { external: "base", href: "/", query: null, target: "_self" },
                React.createElement("div", { dangerouslySetInnerHTML: { __html: props.source } }))));
    }
    return (React.createElement("div", { className: props.className },
        React.createElement(StyledLink, { external: "base", href: "/", query: null, target: "_self" },
            React.createElement(component_icon_1.Icon, { symbol: "patternplate", size: "l" }))));
};
const StyledLogo = styled_components_1.default(InnerLogo) `
  box-sizing: border-box;
  display: flex;
  width: 100%;
  fill: currentColor;
  stroke: currentColor;
  stroke-width: 0;
  align-items: center;
  padding: 10px;
  background: ${props => props.theme.colors.backgroundSecondary};
`;
exports.Logo = props => React.createElement(StyledLogo, Object.assign({}, props));
//# sourceMappingURL=logo.js.map